var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeft12White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.002,
    height: 12,
    viewBox: "0 0 6.002 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,.94,1.392,5.76a.37.37,0,0,0,0,.48L6,11.06l-.93.94L.472,7.18a1.71,1.71,0,0,1,0-2.36L5.072,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft12White);
export default __webpack_public_path__ + "static/media/Icon-ChevronLeft12-White.891798a346384d5eabc7c0305829ac92.svg";
export { ForwardRef as ReactComponent };